import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { StoreUserService } from '@app/core/state/store-user.service';

@Injectable()
export class UpdateSystemAdminService {

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService,
    private msalService: MsalService,
  ) { }

  updateSystemAdmin(userId, putBody) {
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({ 'Content-Type': 'application/json' })
                .set("loginUserId", loginUserId);

    return this.httpClient.put(`${apiConfig.uri}/system/admins/${userId}`, putBody, { headers: headers });
  }

}
